import React from 'react'
import moment from 'moment/moment'
import { useDispatch, useSelector } from 'react-redux'
import { DateRangePicker } from '@/components/ui/date-range-picker'
import { setCloudReportFilters } from '../../Reports/reports.slice'
import { selectCloudReportFilters } from '../../Reports/reports.selectors'

const DateRangeHeaderFilter = ({ column }) => {
	const dispatch = useDispatch()
	const reportFilters = useSelector(selectCloudReportFilters)

	// Convert moment range to DateRange format
	const currentValue = reportFilters[`${column.dataField}`]
	const dateRange = currentValue
		? {
				from: currentValue.start ? new Date(currentValue.start) : undefined,
				to: currentValue.end ? new Date(currentValue.end) : undefined,
			}
		: undefined

	const handleDateRangeChange = (range) => {
		if (range?.from && range?.to) {
			// Create a moment range for compatibility with existing code
			const momentRange = moment.range(range.from, range.to)
			dispatch(
				setCloudReportFilters({
					...reportFilters,
					[`${column.dataField}`]: momentRange,
				})
			)
		} else {
			dispatch(
				setCloudReportFilters({
					...reportFilters,
					[`${column.dataField}`]: undefined,
				})
			)
		}
	}

	const minDate = moment()
		.startOf('year')
		.year(moment().year() - 1)
		.toDate()

	return (
		<div className="calendar-div">
			<DateRangePicker
				dateRange={dateRange}
				onDateRangeChange={handleDateRangeChange}
				minDate={minDate}
				numberOfMonths={1}
				placeholder="Select dates"
			/>
		</div>
	)
}

export default DateRangeHeaderFilter
